export default __webpack_public_path__ + "static/media/MEXC.bf543558.svg";